<form
  [formGroup]="outputForm"
  (ngSubmit)="saveOutput()"
  autocomplete="on"
  class="container-grid"
  [ngStyle]="containerStyles"
>
  <div class="grid-first">
    <label for="tipo-salida-opcion" class="form-label">Tipo de salida*</label>
    <select
      id="tipo-salida-opcion"
      class="form-control"
      [formControl]="tipoSalida"
      *ngIf="movimiento == 'crear'"
    >
      <option *ngFor="let item of outputTypes" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
    <select
      id="tipo-salida-opcion"
      class="form-control"
      formControlName="output_type_option_id"
      *ngIf="movimiento !== 'crear'"
    >
      <option *ngFor="let item of outputTypes" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
  </div>
  <div *ngIf="movimiento !== 'crear'">
    <label for="noOperacion" class="form-label">No. de operación*</label>
    <input
      type="number"
      id="noOperacion"
      class="form-control"
      [value]="id"
      disabled
    />
  </div>
  <div>
    <label for="clave-recinto" class="form-label">Clave del recinto*</label>
    <input
      type="number"
      id="clave-recinto"
      class="form-control"
      formControlName="precinct_key"
    />
  </div>
  <div class="grid-first">
    <label for="fechaRecinto" class="form-label">Fecha de salida de merma*</label>
    <input
      type="date"
      id="fechaRecinto"
      class="form-control"
      formControlName="departure_date"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('departure_date')"
    >
      Ingrese la fecha
    </span>
  </div>
  <div>
    <label for="tonelaje" class="form-label">Tonelaje total de merma*</label>
    <input
      type="number"
      id="tonelaje"
      class="form-control"
      formControlName="total_tonnage"
    />
    <span
    class="form-text text-danger"
    *ngIf="campoEsValido('total_tonnage')"
    >
      Ingrese el tonelaje
    </span>
  </div>
  <div>
    <label for="no-piezas-totales" class="form-label"
      >Piezas totales de merma</label
    >
    <input
      type="number"
      id="no-piezas-totales"
      class="form-control"
      appOnlyNumbers
      [maxDigits]="10"
      formControlName="total_pieces"
    />
  </div>
  <app-amounts-by-input-locations
    class="subtitle"
    [movimiento]="movimiento"
    [locations]="locations"
    [amountsPerYardList]="amountsPerYardList"
    [entryTonnage]="outputForm.get('total_tonnage')?.value"
    [entryPieces]="outputForm.get('total_pieces')?.value"
    [outputDetail]="outputDetail"
  ></app-amounts-by-input-locations>
  <div class="grid-first" *ngIf="isImportationCabotaje">
    <label for="number_custom_agreement" class="form-label">No. de Acuerdo Aduanal*</label>
    <input
      type="text"
      id="number_custom_agreement"
      class="form-control"
      maxlength="50"
      formControlName="number_custom_agreement"
    />
    <span
    class="form-text text-danger"
    *ngIf="campoEsValido('number_custom_agreement')"
    >
      Ingrese el número
    </span>
  </div>
  <div>
    <label for="noBarco" class="form-label">No. de barco*</label>
    <select
      id="noBarco"
      class="form-control"
      formControlName="ship_number"
      (change)="changeBoat()"
    >
      <option value="" disabled>-- Seleccione un número de barco --</option>
      <option value="null">No aplica.</option>
      <option *ngFor="let boat of boats" [value]="boat.boats_number">
        {{ boat.boats_number }}
      </option>
    </select>
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('ship_number')"
    >
      Seleccione número de barco
    </span>
  </div>
  <div>
    <label for="nombreBarco" class="form-label">Nombre de barco*</label>
    <input
      type="text"
      id="nombreBarco"
      class="form-control"
      maxlength="150"
      formControlName="ship_name"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('ship_name')"
    >
      Ingrese el nombre del barco
    </span>
  </div>
  <div class="grid-span2">
    <label for="observaciones" class="form-label">Observaciones</label>
    <input
      type="text"
      id="observaciones"
      class="form-control"
      maxlength="300"
      formControlName="observations"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('observations')"
    >
      Ingrese las observaciones
    </span>
  </div>
  <div class="grid-all container-button">
    <button
      type="button"
      class="btn-lote me-5"
      (click)="regresar()"
      *ngIf="movimiento !== 'crear'"
    >
      Regresar
    </button>
    <button
      type="submit"
      class="btn-lote ms-5"
      *ngIf="movimiento !== 'detalle'"
    >
      Guardar
    </button>
  </div>
</form>
<app-overlay
  *ngIf="overlay"
  [icono]="iconoOverlay"
  [mensaje]="mensajeOverlay"
  [buttons]="buttons"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>
